// src/utils/SiblingsInfo

import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const SiblingOrCommonLawComponent = ({ formData, calculateFamilyConnectionPoints }) => (
  <Box>
    <Typography variant="h6">Family Connection Bonus</Typography>
    <Typography>
      In the Comprehensive Ranking System (CRS), having a sibling in Canada who is a citizen or permanent resident can earn you an additional 15 points.
      While having a common‑law partner does not provide a separate bonus, their profile may affect other CRS factors.
    </Typography>
    {formData?.hasSibling !== undefined && (
      <Typography sx={{ marginTop: 2 }}>
        {formData.hasSibling 
          ? 'You have a qualifying sibling in Canada.'
          : 'You do not have a qualifying sibling in Canada.'}{' '}
        Bonus Points: {calculateFamilyConnectionPoints(formData.hasSibling)}
      </Typography>
    )}
    <Card sx={{ marginTop: 2 }}>
      <CardContent>
        <Typography variant="subtitle1">Bonus Details</Typography>
        <Typography variant="body2">
          • If you have a sibling in Canada who is a citizen or permanent resident, you receive an extra 15 CRS points.
          <br />
          • There is no additional bonus for having a common‑law partner; however, their credentials influence other scoring factors.
          <br />
          • Ensure your sibling meets the eligibility criteria to claim this bonus.
        </Typography>
      </CardContent>
    </Card>
  </Box>
);

export default SiblingOrCommonLawComponent;
